import React, { useState } from "react";
import "./Senate.css";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { useNavigate } from "react-router";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import { addCandidate, ImageUpload } from "../../Sevices/api-requests";
import { Input } from "@material-ui/core";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(12),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  input: {
    display: "none",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function Create({ user }) {
  const [name, setName] = useState("");
  const [position, setPosition] = useState("");
  const [category, setCategory] = useState("");
  const [image, setImage] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [level, setLevel] = useState("");
  const [open, setOpen] = React.useState(false);
  const [error, setError] = useState("");
  const [preview, setPreview] = useState();

  const navigate = useNavigate();
  // Uploading Image to Firebase and getting URL
  const handleFileChange = (e) => {
    console.log("I entered the Handlefile change function");
    const file = e.target.files[0];
    if (file) {
      previewFile(file);
    }
    console.log(image);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const previewFile = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setPreview(reader.result);
    };
  };

  const handleUpload = async (file) => {
    console.log(file);
    const url = await ImageUpload(file);
    setImage(url.data.data.url);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!preview) return;

    try {
      const result = await addCandidate(name, category, level, position, image);
      console.log(result.data.data);
      if (result.data.data) {
        setOpen(true);
        navigate("/candidate/view");
      }

      //window.location.reload()
    } catch (error) {
      setError(error.message);
      setDisabled(false);
    }
  };
  const classSetObj = [
    { level: "100", name: "2k27" },
    { level: "200", name: "2k26" },
    { level: "300", name: "2k25" },
    { level: "400", name: "2k24" },
    { level: "500", name: "2k23" },
    { level: "600", name: "2k21" },
  ];
  const categories = ["legislative", "executive"];
  const positions = [
    "Senator",
    "President",
    "Vice-President",
    "General Secretary",
    "Assistant General Secretary",
    "Treasurer",
    "CODEH Chairman",
    "Sports Secretary",
    "Public Relations Officer",
    "Special Duties Officer",
  ];
  const classes = useStyles();
  return user.matricNo == "220998" || user.matricNo == "213122" ? (
    <Container component="main" style={{ marginBottom: "5%" }} maxWidth="xs">
      <CssBaseline />

      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Add Candidate
        </Typography>
        <form className={classes.form} validate="true">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoComplete="name"
                name="fullName"
                variant="outlined"
                required
                fullWidth
                id="fullName"
                label="Name"
                autoFocus
                value={name}
                onChange={(event) => {
                  const { value } = event.target;
                  setName(value);
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                // className={classes.input}
                name="Image"
                accept="image/*"
                type="file"
                variant="outlined"
                required
                fullWidth
                id="contained-button-file"
                //value ={image}
                onChange={handleFileChange}
              />

              <Button
                style={{ marginTop: "3%" }}
                variant="contained"
                color="primary"
                onClick={() => {
                  handleUpload(preview);
                }}
                component="span"
              >
                Upload Image
              </Button>
            </Grid>

            {preview && (
              <Grid item xs={12}>
                <img
                  src={preview}
                  style={{ height: "300px" }}
                  alt="candidate-image"
                />
              </Grid>
            )}
            {/* <Grid item xs={12} sm={6}>
            <Button 
            variant='contained'
            component="label">
               Upload Avatar
               <input type='file'  
        onChange= {(event) => {
       if(event.target.files[0]){
         setImage(event.target.files[0])
       }
          
        }}
               hidden />
            </Button>
          
          
          </Grid> */}

            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
              <Alert onClose={handleClose} severity="success">
                This is a success message!
              </Alert>
            </Snackbar>
            <Grid item xs={4}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-controlled-open-select-label">
                  Category
                </InputLabel>
                <Select
                  labelId="demo-controlled-open-select-label"
                  id="demo-controlled-open-select"
                  ariant="outlined"
                  required
                  fullWidth
                  label="Category"
                  name="category"
                  autoComplete="category"
                  value={category}
                  onChange={(event) => {
                    const { value } = event.target;
                    setCategory(value);
                  }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {categories.map((c, i) => {
                    return <MenuItem value={c}>{c}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-controlled-open-select-label">
                  Level
                </InputLabel>
                <Select
                  labelId="demo-controlled-open-select-label"
                  id="demo-controlled-open-select"
                  ariant="outlined"
                  required
                  fullWidth
                  label="Level"
                  name="level"
                  autoComplete="level"
                  value={level}
                  onChange={(event) => {
                    const { value } = event.target;
                    setLevel(value);
                  }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {classSetObj.map((c, i) => {
                    return <MenuItem value={c.level}>{c.name}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-controlled-open-select-label">
                  Position
                </InputLabel>
                <Select
                  labelId="demo-controlled-open-select-label"
                  id="demo-controlled-open-select"
                  ariant="outlined"
                  required
                  fullWidth
                  label="Position"
                  name="  Position"
                  autoComplete="level"
                  value={position}
                  onChange={(event) => {
                    const { value } = event.target;
                    setPosition(value);
                  }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {positions.map((c, i) => {
                    return <MenuItem value={c}>{c}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={!image || !name || !category || !position}
            onClick={handleSubmit}
          >
            Add Candidate
          </Button>
        </form>
      </div>
    </Container>
  ) : (
    <Typography style={{ textAlign: "center", marginTop: "50vh" }}>
      You do not have access to view this page
    </Typography>
  );
}
